import { Typography } from '@mui/material'

import appleButton from '/assets/images/add-to-apple-wallet.svg'
import googleButton from '/assets/images/add-to-google-wallet.svg'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Pass Installer</Typography>

      <p>We've provided several options for you to install this pass on a device. You can click the add to wallet buttons:</p>

      <div className='flex flex-row gap-5 justify-between pt-10'>
        <img src={appleButton} width={250} />
        <img src={googleButton} width={250} />
      </div>

      <p>You can scan the barcodes with the camera on your device.</p>

      <p>Or you can copy an install link to share elsewhere.</p>

    </div>
  )
}

export default HelpText